import { LoadingPage } from '@/components/LoadingPage';
import { graphql } from '@/gql/codegen/gql';
import { useQuery } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';
import GoalDialogResultContainer from './-container';

type GoalDialogResultSearch = {
  timeout?: boolean;
};

export const Route = createFileRoute(
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/goal-dialog-result/',
)({
  component: component,
  validateSearch: (search: Record<string, unknown>): GoalDialogResultSearch => {
    // validate and parse the search params into a typed state
    return {
      timeout: search.timeout === 'true' || search.timeout === true,
    };
  },
});

export const GET_GOAL_DIALOG_RESULT = graphql(/* GraphQL */ `
  query GetGoalDialogResult(
    $input: CourseLessonGoalDialogResultInput!
    $embaUserAttendanceSlug: String!
    $embaCourseLessonSlug: String!
  ) {
    embaGoalDialogResult(
      input: $input
    ) {
      ...GoalDialogResult
    }
    embaCourseLesson(
      embaUserAttendanceSlug: $embaUserAttendanceSlug
      embaCourseLessonSlug: $embaCourseLessonSlug
    ) {
      ...EmbaCourseLessonDetail
    }
  }
`);

function component() {
  const { userAttendanceSlug, lessonSlug } = Route.useParams();
  const { timeout } = Route.useSearch();

  // ポーリング時にローディング表示を避けるため、useSuspenseQuery ではなく useQuery を使用
  const { startPolling, stopPolling, error, data } = useQuery(
    GET_GOAL_DIALOG_RESULT,
    {
      variables: {
        input: {
          embaUserAttendanceSlug: userAttendanceSlug,
          embaCourseLessonSlug: lessonSlug,
        },
        embaUserAttendanceSlug: userAttendanceSlug,
        embaCourseLessonSlug: lessonSlug,
      },
      notifyOnNetworkStatusChange: false,
    },
  );

  if (error) {
    throw error;
  }

  // useQuery を使用しているので、手動でローディングの制御が必要。
  // ローディングは、初回データ取得時（data = undefined）のみ表示させ、ポーリング中(data = キャッシュされた値を保持し続ける)は表示させない。
  if (!data) {
    return <LoadingPage />;
  }

  return (
    <GoalDialogResultContainer
      goalDialogResult={data.embaGoalDialogResult}
      courseLesson={data.embaCourseLesson}
      userAttendanceSlug={userAttendanceSlug}
      lessonSlug={lessonSlug}
      startPolling={startPolling}
      stopPolling={stopPolling}
      isTimeout={!!timeout}
    />
  );
}
